import { useState, useEffect, useContext } from 'react'
import ContextStates from '../../context/ContextStates'
import { FaPen, FaTrash } from "react-icons/fa";
import axios from 'axios'
import { Url } from '../Url'


const ListadoMarcas = () => {
    const { setFormView, setViewOpen, marcas, setMarcas, marcaSearch, setMarcaSelected, modify, roles } = useContext(ContextStates)

    useEffect(() => {
        const consultaMarcas = async () => {
            const formData = new FormData()
            formData.append("marca", marcaSearch)
            try {
                const response = await axios({
                    url: Url + 'api/listadomarcas.php',
                    method: 'POST',
                    data: formData,
                })
                setMarcas(response.data.results)
            } catch (e) {
                console.log(e)
            }
        }
        consultaMarcas()
    }, [marcaSearch, modify])

    const handleView = (item, action) => {
        setMarcaSelected(item)
        setFormView(action)
        setViewOpen(true)
    }


    return (
        <div className="w-full py-5 rounded-2xl">
            <div className="sm:items-start">
                <table className='w-full'>
                    <thead>
                        <tr className='p-1 bg-blue-400 text-white'>
                            <th>Marca</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {marcas && (
                            marcas.map((item, index) => (
                                <tr key={index} className={`border border-gray-300 p-2`}>
                                    <td className='text-center'>{item.descripcion}</td>
                                    <td className='text-center'>
                                        {(roles.includes("11")) && (
                                            <>
                                                <button className='bg-gray-400 ml-2 hover:bg-gray-300 rounded p-2 text-white' onClick={() => handleView(item, 10)}><FaPen /></button>
                                                <button className='bg-red-500 ml-2 hover:bg-red-400 rounded p-2 text-white' onClick={() => handleView(item, 11)}><FaTrash /></button>
                                            </>
                                        )}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default ListadoMarcas